import {DateTime, Person, PhoneNumber, TerminalLocation} from "@/modules/models";

export default class UsersWithoutCardReportRow {
    constructor(public person: Person, public phone: PhoneNumber, public firstTimeIn: DateTime, public lastTimeIn: DateTime, public terminalLocation: TerminalLocation) {}

    static fromJson(json: any) {
        const person = Person.fromJson(json.person);
        if(person == null) {
            throw new Error("Person must be set");
        }
        return new UsersWithoutCardReportRow(
            person,
            PhoneNumber.fromJson(json.phone),
            DateTime.fromJson(json.firstTimeIn),
            DateTime.fromJson(json.lastTimeIn),
            TerminalLocation.fromJson(json.terminalLocation)
        )
    }
}